import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col bg-gray-lp-1400 px-2.5 pt-3 pb-6 gap-y-2" }
const _hoisted_2 = { class: "p-3 flex flex-col gap-y-4 bg-white rounded-2xl shadow overflow-auto" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3 rounded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterGrouping = _resolveComponent("FilterGrouping")!
  const _component_TotalRevenueSection = _resolveComponent("TotalRevenueSection")!
  const _component_CardTotalProfit = _resolveComponent("CardTotalProfit")!
  const _component_RevenueMetricFilter = _resolveComponent("RevenueMetricFilter")!
  const _component_RevenueBreakdownFilter = _resolveComponent("RevenueBreakdownFilter")!
  const _component_LineComparisonChart = _resolveComponent("LineComparisonChart")!
  const _component_BreakdownTable = _resolveComponent("BreakdownTable")!
  const _component_TopCommoditySection = _resolveComponent("TopCommoditySection")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_FilterGrouping, {
        dates: _ctx.revenueData.params.dates,
        "onUpdate:dates": _cache[1] || (_cache[1] = ($event: any) => (_ctx.revenueData.params.dates = $event)),
        groupBy: _ctx.revenueData.params.groupBy,
        "onUpdate:groupBy": _cache[2] || (_cache[2] = ($event: any) => (_ctx.revenueData.params.groupBy = $event)),
        onFilter: _ctx.getData
      }, null, 8, ["dates", "groupBy", "onFilter"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_TotalRevenueSection, {
          data: _ctx.stateData,
          onRetry: _ctx.getRevenueOverview
        }, null, 8, ["data", "onRetry"]),
        _createVNode(_component_CardTotalProfit, {
          data: _ctx.stateData,
          onRefresh: _ctx.getRevenueOverview
        }, null, 8, ["data", "onRefresh"])
      ]),
      _createVNode(_component_RevenueMetricFilter, {
        data: _ctx.stateData,
        onFilter: _ctx.getBreakdown
      }, null, 8, ["data", "onFilter"]),
      _createVNode(_component_RevenueBreakdownFilter, {
        data: _ctx.stateData,
        onFilter: _ctx.getBreakdown
      }, null, 8, ["data", "onFilter"]),
      _createVNode(_component_LineComparisonChart, {
        data: _ctx.stateData.breakdownData,
        type: _ctx.stateData.dataGrouping,
        isLoading: _ctx.stateData.isLoadingBreakdown,
        hasError: _ctx.stateData.isErrorBreakdown,
        errorMessage: _ctx.stateData.errorBreakdown
      }, null, 8, ["data", "type", "isLoading", "hasError", "errorMessage"]),
      _createVNode(_component_BreakdownTable, {
        dataTypes: _ctx.stateData.dataGrouping,
        dataBreakdown: _ctx.stateData.breakdownData,
        loading: _ctx.stateData.isLoadingBreakdown,
        error: _ctx.stateData.isErrorBreakdown,
        groupBy: _ctx.revenueData.params.groupBy
      }, null, 8, ["dataTypes", "dataBreakdown", "loading", "error", "groupBy"]),
      (_ctx.isShowTopCommodity)
        ? (_openBlock(), _createBlock(_component_TopCommoditySection, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}